<template>
  <div class="card">
    <slot />
  </div>
</template>

<script>
/**
 * Стилизованнвя кароточка
 * @module Shared/Component/Card
 * */
</script>

<style lang="scss">
.card {
  background: white;
  padding: 40px;
  border-radius: 10px;

  @media screen and (max-width: $breakpoint-lg-max) {
    padding: 30px;
  }

  @media screen and (max-width: $breakpoint-xs-max) {
    padding: 20px 15px;
    border-radius: 0px;
  }
}
</style>
